import {Component, OnInit, Input, ChangeDetectorRef,
  Output, EventEmitter, OnDestroy, ElementRef, ViewChild, AfterViewChecked, Renderer2 } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {forkJoin, Observable, of, Subscription, combineLatest } from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { BroadcastService } from '../services/broadcast.service';
@Component({
    selector: 'app-receiving-lab-dropdown',
    templateUrl: './receiving-lab-dropdown.component.html',
    styleUrls: ['./receiving-lab-dropdown.component.scss'],
    standalone: false
})
export class ReceivingLabDropdownComponent implements OnInit {
  @Input() dataValues: Observable<any> = of([]);
  @Input() persistance: Observable<any> = of([]);
  @Input() placeholder;
  @Input() class;
  @Input() width;
  @Input() blocking: boolean;
  @Output() selectedValues = new EventEmitter();
  @ViewChild('ctrlInput') ctrlInput: ElementRef<HTMLElement>;
  autoCompleteWidth;
  isSearching: boolean;
  isComboxBoxOpen: boolean;
  receivingLabListCtrl = new UntypedFormControl({value : '', disabled: true});
  filteredList = new Array<any>();
  allReceivingLabs = new Array<any>();
  isAllSelected = false;
  noData = false;
  selectedReceivingLabs = new Array<any>();
  subscriptions: Subscription[] = [];
  submittedNumber = 0;
  selectedReceivingLabCopy = new Array<any>();
  constructor(
    private cdr: ChangeDetectorRef, private broadcastService: BroadcastService,
    private renderer: Renderer2, private elementRef: ElementRef) {
    const self = this;
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!self.elementRef.nativeElement.contains(e.target) && self.isSearching) {
        this.dismissSearchBox();
      }
    });
  }

  updateFilterList(list) {
    this.filteredList = list ? this._filter(list) : this.allReceivingLabs.slice();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.dataValues.subscribe((data) => {
      this.allReceivingLabs = data;
      if (this.allReceivingLabs && this.allReceivingLabs.length) { this.receivingLabListCtrl.enable(); this.filteredList = this.allReceivingLabs; }
      
    }));
    this.subscriptions.push(this.persistance.subscribe((data) => {
      this.selectedReceivingLabs = data;
      this.submittedNumber = this.selectedReceivingLabs.length;
      this.isAllSelected = (this.selectedReceivingLabs.length &&
        (this.selectedReceivingLabs.length === this.allReceivingLabs.length));
      this.selectedReceivingLabCopy = [...this.selectedReceivingLabs];
      this.filteredList.forEach(element => {
        element.isSelected =
          (this.selectedReceivingLabs.findIndex((y) => y.labSiteCode === element.labSiteCode)) > -1;
      });
    }));
  }

  ngAfterViewChecked(): void {
    const collection = document.getElementsByClassName('virtual-list');
    const outerInput = collection[collection.length - 1];
    this.autoCompleteWidth = outerInput.getBoundingClientRect();
    this.cdr.detectChanges();
  }

  selectedAll(isSelected) {
    this.isAllSelected = isSelected;
    this.filteredList.forEach(element => {
      element.isSelected = (isSelected) ? true : false;
    });
    if (isSelected) {
      this.selectedReceivingLabs = this.allReceivingLabs;
    } else { this.selectedReceivingLabs = []; }
  }

  selectField(event, list) {
    if (!event.checked) { this.isAllSelected = false; }
    this.filteredList.map(element => {
      if (element === list) {
        element.isSelected = event.checked;
        this.removeSelectedAcc(list, event.checked);
      }
      return element;
    });
  }

  clearAll() {
    this.isAllSelected = false;
    this.filteredList = this.allReceivingLabs.slice();
    this.filteredList.forEach(element => {
      element.isSelected = false;
    });
    this.selectedReceivingLabs = [];
  }

  applyFilter() {
    this.selectedReceivingLabCopy = [...this.selectedReceivingLabs];
    this.submittedNumber = this.selectedReceivingLabs.length;
    this.selectedValues.emit(this.selectedReceivingLabs);
    this.dismissSearchBox();
  }

  setIsSearchingValue()
  {
    if(!this.isSearching) {
    this.isSearching = true;
    }
    else{
    this.isComboxBoxOpen = true;
    }
  }

  getRealSelectedValue() {
    if (this.blocking) {
      this.broadcastService.freezeScreenDropDownOpen();
    }
    if (this.selectedReceivingLabCopy.length && !this.isComboxBoxOpen) {
      this.filteredList.forEach(element => {
        element.isSelected = (this.selectedReceivingLabCopy
            .findIndex((x => x.labSiteCode === element.labSiteCode)) > -1 )
        ? true : false;
      });
      this.selectedReceivingLabs = [...this.selectedReceivingLabCopy];
    }
  }

  private removeSelectedAcc(list , isChecked) {
    const index = this.selectedReceivingLabs.findIndex((u) => u.labSiteCode === list.labSiteCode);
    if (isChecked && index === -1) {
      const filterted = this.allReceivingLabs.find((y) => y.labSiteCode === list.labSiteCode);
      this.selectedReceivingLabs.push(filterted);
    } else {
      this.selectedReceivingLabs = [
        ...this.selectedReceivingLabs.slice(0, index),
        ...this.selectedReceivingLabs.slice(index + 1, this.selectedReceivingLabs.length),
      ];
    }
  }

  private _filter(value: string): any[] {
    const word = [value.toLowerCase().trim()];
    let lab: any[] = [];
    if (word) {
      word.forEach(x => {
        const val = this.allReceivingLabs.filter(o =>
          Object.keys(o).some(k => (o.labSiteCode).toLowerCase().includes(x)));
        val.forEach((y) => { y.isSelected = this.selectedReceivingLabs.findIndex((n) => n.labSiteCode === y.labSiteCode) > -1; });
        lab = lab.concat(val).filter((v, i, a) => a.indexOf(v) === i);
      });
    }
    this.noData = lab.length > 0 ? false : true;
    return lab;
  }

  private dismissSearchBox() {
    const self = this;
    setTimeout(() => {
      self.ctrlInput.nativeElement.blur();
      self.receivingLabListCtrl.setValue('');
      self.filteredList = this.allReceivingLabs.slice();
      self.isSearching = false;
      self.isComboxBoxOpen = false;
      if (this.blocking) {
        this.broadcastService.unFreezeScreenDropDownClose();
      }
    }, 0);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
